// extracted by mini-css-extract-plugin
module.exports = {"container":"switch_password-module__container--1h53R","button":"switch_password-module__button--2LNez"};